// LessonCard.js
import React from "react";

const LessonCard = ({ id, title, image, description, articleLink }) => {
  const handleReadMore = () => {
    window.open(articleLink, "_blank");
  };
  return (
    <div className="p-4 border rounded-md overflow-hidden shadow-md">
      <img src={image} alt={title} className="w-full object-contain mb-4" />
      <h3 className="text-xl font-bold mb-2">
        {id}-{title}
      </h3>
      <p className="text-gray-700 text-left">{description}</p>
      <button
        className="bg-blue-700 text-white py-2 px-4 rounded-full mt-4 hover:bg-blue-600"
        onClick={handleReadMore}
      >
        Read Article
      </button>
    </div>
  );
};

export default LessonCard;
